export default __webpack_public_path__ + "static/media/roundEnd.102140f1.mp3";